/* 🤖 this file was generated by svg-to-ts*/
export const icoShoppingCart: {
  name: 'shopping-cart';
  data: string;
} = {
  name: 'shopping-cart',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 19a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM4.5 3a1 1 0 01.927.624l.039.116L6.477 7.5H21a1 1 0 01.994 1.112l-.02.117-2 8.5a1 1 0 01-.86.765L19 18H8a1 1 0 01-.927-.624l-.039-.116L3.733 5H3a1 1 0 01-.993-.883L2 4a1 1 0 01.883-.993L3 3h1.5zm15.237 6.5H7.016l1.75 6.5h9.441l1.53-6.5z" fill="#909090"/></svg>`
};
